import { Link, useLocation } from "react-router-dom";

export default function NavBar() {
  const { pathname } = useLocation();

  const items = [
    { href: "/", label: "Hjem" },
    { href: "/om-os", label: "Om os" },
    { href: "/for-vikarer", label: "Vikarer" },
    { href: "/for-institutioner", label: "Institutioner" },
  ];

  return (
    <nav className="md:hidden sticky top-16 z-30 bg-white/95 backdrop-blur-sm border-b border-slate-100">
      <div className="mx-auto max-w-7xl">
        <ul className="flex gap-1 px-4 py-2 text-xs font-medium text-slate-500 overflow-x-auto scrollbar-hide whitespace-nowrap">
          {items.map((i) => (
            <li key={i.href} className="flex-shrink-0">
              <Link
                className={`inline-block px-3 py-1.5 rounded-full transition-colors ${
                  pathname === i.href
                    ? "text-brand-600 bg-brand-50"
                    : "hover:bg-slate-50 hover:text-slate-900"
                }`}
                to={i.href}
              >
                {i.label}
              </Link>
            </li>
          ))}
          <li className="flex-shrink-0">
            <Link
              className={`inline-block px-3 py-1.5 rounded-full transition-colors ${
                pathname === "/kontakt"
                  ? "text-brand-600 bg-brand-50"
                  : "hover:bg-slate-50 hover:text-slate-900"
              }`}
              to="/kontakt"
            >
              Kontakt
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
